import styled, { css } from 'styled-components';
import { Tag } from 'ui';
import type { NotificationGroup } from './types';

export const getGroupColors = (theme: any): Record<NotificationGroup, string> => ({
  listings: theme.listingNotifications,
  offers: theme.offerNotifications,
  deals: theme.dealsNotifications,
  orders: theme.orderNotifications,
  messages: theme.messageNotifications,
  reservations: theme.reservationNotifications,
  transaction: theme.transactionNotifications,
  other: theme.underTextColor,
});

const SIZE_DIMENSIONS = {
  sm: { width: 104, height: 22, paddingX: 8,  fontSize: 12, lineHeight: 18 },
  md: { width: 160, height: 24, paddingX: 10, fontSize: 12, lineHeight: 18 },
} as const;

export const Pill = styled(Tag).attrs({ bordered: false })<{
  $size: 'sm' | 'md';
  $group?: NotificationGroup;
}>`
  ${({ theme, $size, $group }) => {
  const s = SIZE_DIMENSIONS[$size];
  const groupColors = getGroupColors(theme);
  const bg = $group ? groupColors[$group] : undefined;

  return css`
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 2px;

      width: ${s.width}px;
      height: ${s.height}px;
      padding: 2px ${s.paddingX}px;
      border-radius: 36px;

      color: ${theme.white};
      background-color: ${bg};
      border: none;

      font-family: ${theme.fontText};
      font-weight: 500;
      font-size: ${s.fontSize}px;
      line-height: ${s.lineHeight}px;
      white-space: nowrap;

      &:focus-visible {
        outline: 2px solid ${theme.focusRingColor};
        outline-offset: 2px;
      }
    `;
}}
`;
